import React from 'react';
import { Link } from 'react-router-dom';

const EUProcessingSection = () => {
  const assurances = [
    'Private until you publish',
    'Processed in Europe',
    'Not used to train AI models',
  ];

  return (
    <section className="border-y border-border/60 bg-muted/35 px-5 py-16 md:px-8 md:py-24" aria-labelledby="trust-title">
      <div className="mx-auto max-w-6xl">
        <p className="mb-3 text-xs font-semibold uppercase text-primary">Trust by design</p>
        <h2 id="trust-title" className="max-w-3xl text-3xl font-medium md:text-4xl">
          Unpublished work deserves a private space
        </h2>

        <div className="mt-10 max-w-3xl">
          <p className="text-xl font-medium leading-8">
            A draft stays private until you choose to publish it. It is not listed publicly and is not used to train AI models.
          </p>
          <p className="mt-6 text-base leading-7 text-muted-foreground">
            Manuscript storage, compilation, and AI processing take place in Europe.
          </p>
          <p className="mt-4 text-base leading-7 text-muted-foreground">
            Literature searches send a sanitized, non-personal query to an external bibliographic service. See{' '}
            <Link to="/eu-processing" className="text-primary hover:underline">
              how EU processing and service boundaries work
            </Link>{' '}
            for the full scope.
          </p>
        </div>

        <ul aria-label="Privacy and processing assurances" className="mt-10 grid border-y border-border/70 py-5 text-sm font-medium sm:grid-cols-3 sm:divide-x sm:divide-border/70">
          {assurances.map((assurance) => (
            <li key={assurance} className="py-2 text-foreground first:pt-0 last:pb-0 sm:px-6 sm:py-0 sm:first:pl-0 sm:last:pr-0">
              {assurance}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default EUProcessingSection;
